import styled from 'styled-components';
export const StyledVisuallyHidden = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  ${({ $focusable }) => $focusable &&
    `
    &:focus,
    &:focus-within {
      position: static;
      width: auto;
      height: auto;
      margin: 0;
      overflow: visible;
      clip: auto;
      white-space: normal;
    }
  `}
`;
//# sourceMappingURL=VisuallyHidden.styled.js.map